var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13.455,
  height: 8,
  viewBox: "0 0 13.455 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.455 1.273 12.182 0 6.727 5.454 1.273 0 0 1.273 6.727 8z"
})));
export default SvgDownArrow;